// extracted by mini-css-extract-plugin
export var acceptButton = "_15-6";
export var backdropBlur = "_15-0";
export var fullContent = "_15-5";
export var link = "_15-7";
export var linkIcon = "_15-8";
export var sideContent = "_15-4";
export var sideImage = "_15-3";
export var sideImageWrapper = "_15-2";
export var splitLayout = "_15-1";